const key = 'jB-QagQWOOBTFWGhCVnX58vW_WEmLJ1_ebako2jyExM'
export default key;
